import React from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'

import { jobsActions, jobSettingsActions } from '../../../../../store/slices'
import { selectAll, selectIds } from '../../../../../store/selectors'

import {
  Button,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
} from '../../../../../../../components/Common'

import { DuplicateJobSchema } from '../../../../../common/validation'
import { reduxBatch } from '@manaflair/redux-batch'

import { useFormik } from 'formik'

const DuplicateModal = ({ show, toggle, job }) => {
  const dispatch = useDispatch()
  const jobIds = useSelector(selectIds)
  const jobs = useSelector(selectAll)

  const handleDuplicateJob = (value) => {
    if (jobIds.includes(value.jobID)) {
      formik.setFieldError('jobID', 'This Job ID has already been used. Please make it unique')
    } else {
      // Job Data to be duplicated
      const duplicatedJobInputs = Object.assign({}, job.jobInputs, {
        jobSettings: { ...job.jobInputs.jobSettings, jobID: value.jobID.trim() },
      })
      const jobData = Object.assign({}, job, { uid: value.jobID, jobInputs: duplicatedJobInputs })

      // JobID logic to automatically advance in number sequence
      const newJobID = `Job ${jobs.length + 2}` // 1 for current length of jobs array and 1 for current job to be added
      reduxBatch([
        dispatch(jobsActions.jobAdded(jobData)),
        dispatch(jobSettingsActions.updateInput({ jobID: newJobID })),
      ])

      toggle()
    }
  }

  const formik = useFormik({
    initialValues: {
      jobID: job.uid,
    },
    validationSchema: DuplicateJobSchema,
    onSubmit: handleDuplicateJob,
  })

  return (
    <Modal
      className="job-modal"
      show={show}
      onHide={toggle}
      footer={
        <Modal.Footer>
          <div className="w-full d-flex justify-center items-center gap-x-4">
            <Button
              className="button -xsmall"
              variant="text"
              type="submit"
              form="duplicate-job-form"
              disabled={!formik.isValid || !formik.dirty}
            >
              <span className="material-icons">save</span>
              <span className="button__text">Save Job</span>
            </Button>
            <Button className="button -xsmall" variant="text" onClick={toggle}>
              <span className="material-icons">close</span>
              <span className="button__text">Close</span>
            </Button>
          </div>
        </Modal.Footer>
      }
    >
      <div className="d-flex flex-column justify-center items-center gap-y-4 py-8">
        <p className="mt-0">Assign a new ID for the duplicated job.</p>
        <form id="duplicate-job-form" onSubmit={formik.handleSubmit}>
          <FormGroup>
            <FormLabel htmlFor="jobID">Job ID</FormLabel>
            <FormControl
              id="jobID"
              name="jobID"
              onChange={formik.handleChange}
              value={formik.values.jobID}
              error={formik.errors.jobID}
            />
          </FormGroup>
        </form>
      </div>
    </Modal>
  )
}

DuplicateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  job: PropTypes.objectOf(PropTypes.any),
}

export default DuplicateModal
